export default __webpack_public_path__ + "static/media/instagram-logo.98817f1f.svg";